/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AppointmentBookingSuccess
 */
export interface AppointmentBookingSuccess {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentBookingSuccess
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof AppointmentBookingSuccess
     */
    appointmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof AppointmentBookingSuccess
     */
    bookingId: ApiUserTasksGetLastSelectedIdParameter;
}

/**
 * Check if a given object implements the AppointmentBookingSuccess interface.
 */
export function instanceOfAppointmentBookingSuccess(value: object): value is AppointmentBookingSuccess {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function AppointmentBookingSuccessFromJSON(json: any): AppointmentBookingSuccess {
    return AppointmentBookingSuccessFromJSONTyped(json, false);
}

export function AppointmentBookingSuccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentBookingSuccess {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['appointmentId']),
        'bookingId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['bookingId']),
    };
}

export function AppointmentBookingSuccessToJSON(json: any): AppointmentBookingSuccess {
    return AppointmentBookingSuccessToJSONTyped(json, false);
}

export function AppointmentBookingSuccessToJSONTyped(value?: AppointmentBookingSuccess | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['appointmentId']),
        'bookingId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['bookingId']),
    };
}

